export const backgrounds: string[] = [
  './images/background1.jpg',
  './images/background2.jpg',
  './images/background3.jpg',
  './images/background4.jpg',
];
